import { validateBookingInterval as validateViaEdgeFunction } from '@/services/edgeFunctionWrappers/bookingsManagementWrapper';
import { useUserStore } from '@/store/userStore';

export interface BookingValidationResult {
  isValid: boolean;
  message?: string;
  conflictingBookingDateTime?: Date;
}

/**
 * Vérifie si l'utilisateur peut réserver une séance en respectant la règle des 48h
 * Aucun autre booking (passé ou futur) ne doit être à moins de 48h de la nouvelle réservation
 * 
 * ✅ Isolé par gym - les réservations dans d'autres gyms n'affectent pas la validation
 */
export const validateBookingInterval = async (
  userId: string, 
  newBookingDate: string, 
  newBookingTime: string
): Promise<BookingValidationResult> => {
  try {
    const gymId = useUserStore.getState().gymId;
    
    if (!gymId) {
      console.warn('[validateBookingInterval] No gymId found, allowing booking');
      return { isValid: true };
    }

    // ✅ Appel via edge function - plus d'appel direct à Supabase
    const { data, error } = await validateViaEdgeFunction(
      gymId,
      userId,
      newBookingDate,
      newBookingTime
    );

    if (error) {
      console.error('[validateBookingInterval] Edge function error:', error);
      return { isValid: true }; // Fail open
    }

    return {
      isValid: data?.isValid ?? true,
      message: data?.message,
      conflictingBookingDateTime: data?.conflictingBookingDateTime 
        ? new Date(data.conflictingBookingDateTime) 
        : undefined
    };
  } catch (error) {
    console.error('[validateBookingInterval] Error:', error);
    return { isValid: true }; // Fail open en cas d'erreur
  }
};
